//
//
//
//
//
//
//

import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global'
export default {
  data (){
    return {
      show_1:false,
      code:'',
      state:'',
      messageWarn:'',
      temp:''
    }
  },
  components:{
    loadPage

  },
  beforeMount(){
    if(this.$router.history.current.path == "/temporaryPay"){
      document.title = "费用缴纳";
    }
  },
  mounted: function(){
    this.code = this.$router.history.current.query.code;
    this.state = this.$router.history.current.query.state;
    let url = '';
    if(this.state == 0){
      url = global.host + 'users/getuserid?code='+this.code
    }else{
      url = global.host + 'users/getuser?code='+this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
    }
    if(url){
      this.$http.get(url).then(function(res){
        if(res.body.success){
          this.$router.replace({path:'/feePayment',query:{comnCode:this.state,openid:res.body.result.openId,phone:res.body.result.mainPhone}})
        }else{
          this.$router.replace({path:'/register',query:{openid:res.body.statusCode,nickname:JSON.parse(res.body.message).nickname,headerimgurl:JSON.parse(res.body.message).headimgurl}})
        }
      },function(err){
        console.log(err);;
      })
    }
  },
  methods:{
    iterator(obj){
      let str = '';
      for (let prop of obj ){
        if(typeof obj[prop] === 'object'){
          continue
        }else if(typeof obj[prop] === 'function'){
          continue
        }else{
          str = str + prop + ':' + obj[prop];
        }
      }
      return str;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/temporaryCharge/temporaryPay.vue